import { DeliveryStatus } from "aws-sdk/clients/cloudtrail"
import { TableName } from "aws-sdk/clients/dynamodb"

export type SalePriceItem = {
    productId: string
    price?: number
    quantity: number
}

export type ItemPriceOutlineType = {
    productId: string
    customerTypeYield: number
    customerUnitSubtotal: number
    productDiscountsUnitSubtotal: number
    specialDiscountUnitSubtotal: number
    paymentTypeUnitSubtotal: number
    unitSubtotal: number
    unitVatAmount: number
    unitTotal: number
    quantity: number
    subtotal: number
    customerAdjustmentAmount: number
    discountedAmount: number
    paymentTypeAdjustmentAmount: number
    totalWithoutVAT: number
    vatAmount: number
    total: number
}

export type ItemPriceBreakdownType = {
    productId: string
    customerTypeYield: number
    customerUnitSubtotal: number
    productDiscountsUnitSubtotal: number
    specialDiscountUnitSubtotal: number
    paymentTypeUnitSubtotal: number
    unitSubtotal: number
    unitVatAmount: number
    unitTotal: number
    quantity: number
    subtotal: number
    customerAdjustmentAmount: number
    discountedAmount: number
    paymentTypeAdjustmentAmount: number
    totalWithoutVAT: number
    vatAmount: number
    total: number
}

export type PriceOutlineType = {
    subtotal: number
    customerAdjustmentAmount: number
    discountedAmount: number
    paymentTypeAdjustmentAmount: number
    totalWithoutVAT: number
    vatAmount: number
    perceptionsAmount: number
    total: number
    items: ItemPriceOutlineType[]
}

export enum ItemValidation {
    NOT_EMPTY,
    DEFINED_LOT,
    AVAILABLE_STOCK,
    RESERVED_STOCK,
    NOT_LOWER_THAN_PENDING,
    FOR_SALE
}

export type DeliveryFilters = {
    currentBranchId?: string
    searchText?: string
    table?: TableName
    customerId?: string
    deliveryStatus?: DeliveryStatus
    creationDateFrom?: Date
    creationDateTo?: Date
    dateFrom?: Date
    dateTo?: Date
}
